export const CHAT_MEDIA_LIMITS = Object.freeze({
  imagem: 20 * 1024 * 1024,
  video: 100 * 1024 * 1024,
  audio: 16 * 1024 * 1024,
  documento: 100 * 1000 * 1000,
});

const LABELS = { imagem: 'foto', video: 'vídeo', audio: 'áudio', documento: 'documento' };

export function mediaLimitMessage(tipo) {
  const limitMb = tipo === 'documento' ? CHAT_MEDIA_LIMITS.documento / 1000000
    : Math.floor((CHAT_MEDIA_LIMITS[tipo] || 0) / 1024 / 1024);
  return `${tipo === 'imagem' ? 'Esta' : 'Este'} ${LABELS[tipo] || 'arquivo'} é maior que o limite de ${limitMb} MB.`
    + (tipo === 'documento' ? ' Compartilhe um link de acesso ao arquivo ou reduza seu tamanho.' : '');
}
